import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 环境列表
export const setOutputEnvs: Mutation<IModuleState> = (state, payload) => {
  state.envs.data = payload.data;
  state.envs.loading = !!payload.loading;
};

// 迁移结果
export const setOutputResult: Mutation<IModuleState> = (state, payload) => {
  state.result.data = payload.data;
  state.result.loading = !!payload.loading;
};

// 专案
export const setOutputDesigns: Mutation<IModuleState> = (state, payload) => {
  state.designs.data = payload.data;
  state.designs.total = payload.total || 0;
  state.designs.pageNum = payload.pageNum || 0;
  state.designs.pageSize = payload.pageSize || 0;
  state.designs.loading = !!payload.loading;
};

// 专案展示
export const setOutputDesignShows: Mutation<IModuleState> = (state, payload) => {
  state.designShows.data = payload.data;
  state.designShows.total = payload.total || 0;
  state.designShows.pageNum = payload.pageNum || 0;
  state.designShows.pageSize = payload.pageSize || 0;
  state.designShows.loading = !!payload.loading;
};

// 样板间
export const setOutputRooms: Mutation<IModuleState> = (state, payload) => {
  state.rooms.data = payload.data;
  state.rooms.total = payload.total || 0;
  state.rooms.pageNum = payload.pageNum || 0;
  state.rooms.pageSize = payload.pageSize || 0;
  state.rooms.loading = !!payload.loading;
};

// 地图
export const setOutputMaps: Mutation<IModuleState> = (state, payload) => {
  state.maps.data = payload.data;
  state.maps.total = payload.total || 0;
  state.maps.pageNum = payload.pageNum || 0;
  state.maps.pageSize = payload.pageSize || 0;
  state.maps.loading = !!payload.loading;
};

// 静态贴图包
export const setOutputPacks: Mutation<IModuleState> = (state, payload) => {
  state.packages.data = payload.data;
  state.packages.total = payload.total || 0;
  state.packages.pageNum = payload.pageNum || 0;
  state.packages.pageSize = payload.pageSize || 0;
  state.packages.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
